export var TemperatureControlLabel;
(function (TemperatureControlLabel) {
    TemperatureControlLabel["TEMP_SENSOR"] = "Temperature Sensor";
    TemperatureControlLabel["SET_POINT"] = "Set Point";
    TemperatureControlLabel["HYSTERESIS"] = "Hysteresis";
    TemperatureControlLabel["TIMETABLE"] = "Timetable";
    TemperatureControlLabel["BIAS"] = "Offset";
    TemperatureControlLabel["BIAS_START"] = "Start Offset";
    TemperatureControlLabel["BIAS_END"] = "End Offset";
    TemperatureControlLabel["OUTSIDE_OF_TIMETABLE"] = "Outside of Timetable";
    TemperatureControlLabel["OUTSIDE_SET_POINT"] = "Outside Set Point";
    TemperatureControlLabel["ONLINE_STATUS"] = "Status";
    TemperatureControlLabel["LIVE_TEMPERATURE"] = "Live Temperature";
    TemperatureControlLabel["LOCAL_OVERRIDE"] = "Local Override";
})(TemperatureControlLabel || (TemperatureControlLabel = {}));
export var OutsideTimeTable;
(function (OutsideTimeTable) {
    OutsideTimeTable["SET_POINT"] = "Set point";
    OutsideTimeTable["SWITCH_OFF"] = "Switch off";
})(OutsideTimeTable || (OutsideTimeTable = {}));
